export class UpdateCPUBenchmarkRequest {

    CPUBenchmarkID: number;
    NewBenchmarkScore: number;

}